import { SectionHeading, Button } from "../../design-system";
import React, { useState } from "react";
import { FeedItem } from "../../components";
import { NewsData } from "./News.data";

const News = () => {
  const [news] = useState(NewsData);
  const [loadAll, setLoadAll] = useState<boolean>(false);

  return (
    <section className="min-w-0 scroll-mt-[25px]" aria-labelledby="news-title">
      <SectionHeading id="news-title" title="NOVIDADES" eyebrow="" number="2026" />
      {news &&
        (loadAll ? news : news.slice(0, 5)).map((item, index) => {
          return <FeedItem key={`${item.date}-${index}`} {...item} />;
        })}
      {!loadAll && (
        <div className="mt-6">
          <Button variant="outline" size="detail" fullWidth className="justify-between" type="button" onClick={() => setLoadAll(true)}>CARREGAR MAIS NOVIDADES <span aria-hidden="true">↓</span></Button>
        </div>
      )}
    </section>
  );
};

export default News;
